import React from "react";

export default function VideoOverlay({ layers = [], selectedId, showAudioControls = false, isStreamView = false, canvas = null }) {
  // دالة للتحقق من رؤية الطبقة بناءً على المجموعات
  const isLayerVisible = (layer) => {
    if (!canvas) return layer.visible !== false;
    
    // إذا كانت الطبقة مخفية مباشرة، ارجع false
    if (layer.visible === false) return false;
    
    // تحقق من المجموعات
    const layerGroups = canvas.groups?.filter(group => group.layers && group.layers.includes(layer.id)) || [];
    
    // إذا كانت الطبقة في مجموعة مخفية، ارجع false
    for (const group of layerGroups) {
      if (group.visible === false) return false;
    }
    
    return true;
  };
  // التأكد من أن layers موجود ومصفوفة
  if (!layers || !Array.isArray(layers)) {
    return null;
  }

  // إذا كانت شاشة العرض، اعرض الفيديو والصوت
  if (isStreamView) {
    return (
      <>
        {/* طبقات الفيديو */}
        {layers.filter(l => l.type === "video" && isLayerVisible(l)).map(layer => (
          <video
            key={layer.id}
            src={layer.content}
            autoPlay loop muted playsInline
            style={{
              position: "absolute",
              left: layer.x,
              top: layer.y,
              width: layer.width,
              height: layer.height,
              opacity: layer.opacity,
              pointerEvents: "none",
              zIndex: 2,
              borderRadius: 8,
              transform: `rotate(${layer.rotation || 0}deg)`,
              transformOrigin: "center center"
            }}
          />
        ))}
        
        {/* طبقات الصوت */}
        {layers.filter(l => l.type === "audio" && isLayerVisible(l)).map(layer => (
          <audio
            key={layer.id}
            src={layer.content}
            autoPlay
            style={{
              position: "absolute",
              left: layer.x,
              top: layer.y,
              width: layer.width || 320,
              opacity: layer.opacity,
              zIndex: 3,
              display: 'none' // إخفاء عناصر الصوت في شاشة العرض
            }}
          />
        ))}
      </>
    );
  }

  // للوحة التحكم - عرض مع العناصر الإضافية
  return (
    <div style={{
      position: 'relative',
      width: '100%',
      minHeight: '100px',
      border: '1px solid var(--border-color)',
      borderRadius: '8px',
      padding: '10px',
      background: 'var(--bg-secondary)',
      marginTop: '10px'
    }}>
      <h3 style={{
        margin: '0 0 10px 0',
        color: 'var(--text-primary)',
        fontSize: '16px',
        fontWeight: 'bold'
      }}>
        معالج الفيديو والصوت
      </h3>
      
      {/* طبقات الفيديو */}
      {layers.filter(l => l.type === "video" && isLayerVisible(l)).map(layer => (
        <video
          key={layer.id}
          src={layer.content}
          autoPlay loop muted playsInline
          style={{
            position: "absolute",
            left: layer.x,
            top: layer.y,
            width: layer.width,
            height: layer.height,
            opacity: layer.opacity,
            pointerEvents: "none",
            zIndex: 2,
            borderRadius: 8,
            transform: `rotate(${layer.rotation || 0}deg)`,
            transformOrigin: "center center",
            border: selectedId === layer.id ? '2px dashed #ac76f4' : 'none'
          }}
        />
      ))}
      
      {/* طبقات الصوت */}
      {layers.filter(l => l.type === "audio" && isLayerVisible(l)).map(layer => (
        <audio
          key={layer.id}
          src={layer.content}
          controls={showAudioControls}
          autoPlay
          style={{
            position: "absolute",
            left: layer.x,
            top: layer.y,
            width: layer.width || 320,
            opacity: layer.opacity,
            zIndex: 3,
            background: "#fff9",
            borderRadius: 8,
            transform: `rotate(${layer.rotation || 0}deg)`,
            transformOrigin: "center center",
            border: selectedId === layer.id ? '2px dashed #ffa500' : 'none',
            display: showAudioControls ? 'block' : 'none'
          }}
        />
      ))}
      
      {layers.filter(l => (l.type === "video" || l.type === "audio") && l.visible !== false).length === 0 && (
        <p style={{
          color: 'var(--text-secondary)',
          textAlign: 'center',
          margin: '20px 0',
          fontSize: '14px'
        }}>
          لا توجد طبقات فيديو أو صوت لعرضها
        </p>
      )}
    </div>
  );
}
